import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Calendar as CalendarIcon, ChevronRight } from "lucide-react";

const TYPE_DOT = {
    pushim: "bg-terracotta",
    provim: "bg-amber-500",
    aktivitet: "bg-sage",
    takim: "bg-oxford",
};

export default function UpcomingEvents({ days = 14, limit = 4, className = "" }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        api.get("/events/upcoming", { params: { days } })
            .then((r) => alive && setItems((r.data?.items || []).slice(0, limit)))
            .catch(() => {})
            .finally(() => alive && setLoading(false));
        return () => { alive = false; };
    }, [days, limit]);

    if (loading) return null;

    return (
        <Link to="/calendar" data-testid="upcoming-events-card"
            className={`group bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-oxford hover:shadow-md transition block ${className}`}>
            <div className="px-4 py-3 border-b border-slate-200 bg-bone/40 flex items-center gap-2">
                <CalendarIcon className="w-4 h-4 text-oxford" />
                <div className="text-xs uppercase tracking-widest font-bold text-slate-700">Kalendari — Të ardhshme</div>
                <div className="ml-auto flex items-center gap-1 text-xs text-oxford font-bold">
                    {items.length > 0 && `${items.length}`} <ChevronRight className="w-3 h-3 group-hover:translate-x-0.5 transition" />
                </div>
            </div>
            {items.length === 0 ? (
                <div className="p-4 text-center text-xs text-slate-500">Asnjë ngjarje në {days} ditët e ardhshme</div>
            ) : (
                <div className="divide-y divide-slate-200">
                    {items.map((e) => (
                        <div key={e.id} className="px-4 py-2.5 flex items-center gap-3">
                            <div className={`w-2 h-2 rounded-full shrink-0 ${TYPE_DOT[e.event_type] || "bg-slate-400"}`} />
                            <div className="flex-1 min-w-0">
                                <div className="text-sm font-bold text-slate-900 truncate">{e.title}</div>
                                <div className="text-[11px] text-slate-500">
                                    {e.date_from === e.date_to ? e.date_from : `${e.date_from} – ${e.date_to}`}
                                    {e.class_name && ` • ${e.class_name}`}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Link>
    );
}
